'use strict';

import $ from 'jquery';
const slick = require('slick-carousel-browserify');

const videojs = require('video.js');
const youtube = require('videojs-youtube');

export default class ImagesCarousel {
  constructor() {

    this.player = null;

    if ( $('*[data-js="carousel-video"]').length > 0 ) {
      this.player = videojs('carousel-player');

      this.player.on('ended', () => {
        this.clickBind();
        $('*[data-js="carousel-video"]').removeClass('playing');
      });

      this.clickBind();
    }

    // Contamos el número total de slides y configuramos la inicial
    const slideCount = $('*[data-js="carousel-nav"] > div').length;
    let initialSlide = 0;
    if ( slideCount % 2 === 0 ) {
      initialSlide = slideCount / 2 - 1;
    } else {
      initialSlide = Math.floor(slideCount/2) + 1;
    }

    $('*[data-js="images-carousel"]').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      initialSlide: initialSlide,
      adaptiveHeight: false,
      arrows: true,
      fade: true,
      infinite: false,
      asNavFor: '.carousel__nav',
      prevArrow: `
        <button type="button" class="custom-prev">Previous</button>
      `,
      nextArrow: `
        <button type="button" class="custom-next">Previous</button>
      `,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            arrows: false
          }
        },{
          breakpoint: 480,
          settings: {
            arrows: false
          }
        }
      ]
    });

    $('*[data-js="carousel-nav"]').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      initialSlide: initialSlide,
      asNavFor: '.carousel',
      dots: false,
      arrows: false,
      centerMode: true,
      centerPadding: '0px',
      focusOnSelect: true,
      infinite: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            centerPadding: '40px',
          }
        },{
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerPadding: '80px',
          }
        }
      ]
    });
    $('*[data-js="images-carousel"]').on('afterChange', () => {
      if ( this.player !== null ){
        this.player.pause();
      }
    });
  }

  clickUnbind() {
    $('*[data-js="carousel-video"]').unbind('click');
  }

  clickBind() {
    $('*[data-js="carousel-video"]').on('click', (event) => {
      const $delegateTarget = $(event.delegateTarget);
      $delegateTarget.addClass('playing');

      $delegateTarget.find('.video-js').css('display','block');
      $delegateTarget.find('video').css('display','block');

      this.clickUnbind();
      this.player.play();
    });
  }
}
